import React from 'react';
import Main from './application/Main'
import './assets/css/style.css';

function App() {
  return (
      <Main />
  )
}

export default App;
